import "./GoedgekeurdDoor.scss";

const GoedgekeurdDoor = (props) =>{

    return(
        <p className="goedgekeurdDoor"> Goedgekeurd door {props.name} {props.date}</p>
    );
}

export default GoedgekeurdDoor;